import moment from 'moment';
import { TFunction } from 'i18next';
import { localizeDate } from '@pec/aion-ui-i18next/helpers/localize';
import { formats } from '@pec/aion-ui-i18next/constants';

/**
 * Formats a subscription expiration date as MM/DD/YYYY, deriving the calendar day in local time
 * so the subscription banner and the subscription alert always render the identical string.
 */
export const localizeSubscriptionExpiration = (expirationDate: string | null, t: TFunction): string =>
  expirationDate
    ? localizeDate(
        {
          value: moment(`${moment(expirationDate).format('YYYY-MM-DD')}T00:00:00`).toISOString(),
          config: { day: '2-digit', month: '2-digit', year: 'numeric' }
        },
        t,
        formats.dateCustom
      )
    : '';
